"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "addTemplateToBackground", {
  enumerable: true,
  get: function get() {
    return _addTemplateToMedia["default"];
  }
});
Object.defineProperty(exports, "addTemplateToMedia", {
  enumerable: true,
  get: function get() {
    return _addTemplateToMedia["default"];
  }
});
Object.defineProperty(exports, "createFromTemplate", {
  enumerable: true,
  get: function get() {
    return _createFromTemplate["default"];
  }
});
Object.defineProperty(exports, "getEventMedia", {
  enumerable: true,
  get: function get() {
    return _getEventMedia["default"];
  }
});
Object.defineProperty(exports, "getTemplates", {
  enumerable: true,
  get: function get() {
    return _getTemplates["default"];
  }
});
var _addTemplateToMedia = _interopRequireDefault(require("./addTemplateToMedia"));
var _createFromTemplate = _interopRequireDefault(require("./createFromTemplate"));
var _getEventMedia = _interopRequireDefault(require("./getEventMedia"));
var _getTemplates = _interopRequireDefault(require("./getTemplates"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }